module.exports = "/_next/static/images/30bf18525a3e30f8d2d2937272c8269a-cristina-desktop.jpg";